module.exports = __webpack_public_path__ + "static/media/blog-1.f8a971d4.jpg";